import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpApiService } from '../http.api.service';
import { EfateSetup } from '../../models/echo/efate-setup';
import { EfateCakeDataSet } from '../../models/echo/efate-cake-data-set';
import { EfateStudyOptions } from '../../models/echo/efate-study-options';

@Injectable({
  providedIn: 'root'
})
export class EfateSetupApiService extends HttpApiService {
  override apiUrl: string = environment.BAMS_Api_URL;

  getEfateSetupByMoleculeAndGeography(moleculePk: number, geography: string): Observable<EfateSetup | undefined> {
    const endpoint = `api/efate/setup/${moleculePk}/${encodeURIComponent(geography)}`;
    return this.get(endpoint).pipe(map((data: any) => data?.Value ?? data));
  }

  getEfateCakeTopologyBySetupPk(efateSetupPk: number): Observable<any> {
    const endpoint = `api/efate/cakeTopology/${efateSetupPk}`;
    return this.get(endpoint).pipe(map((data: any) => data?.Value ?? data));
  }

  getEfateCakeDataSetsBySetupPk(efateSetupPk: number): Observable<EfateCakeDataSet[]> {
    const endpoint = `api/efate/cakeDataSet/${efateSetupPk}`;
    return this.get(endpoint).pipe(map((data: any) => data?.Value ?? data));
  }

  getEfateStudyOptionsByDatasetPk(datasetPk: number): Observable<EfateStudyOptions | undefined> {
    const endpoint = `api/efate/studyOptions/dataset/${datasetPk}`;
    return this.get(endpoint).pipe(map((data: any) => this.unwrapActionResult(data)));
  }

  getEfateStudyOptionsBySetupPk(efateSetupPk: number): Observable<EfateStudyOptions[]> {
    const endpoint = `api/efate/studyOptions/${efateSetupPk}`;
    return this.get(endpoint).pipe(map((data: any) => this.unwrapActionResult(data) ?? []));
  }

  runCAKE(efateSetupPk: number): Observable<any> {
    const endpoint = `api/efate/runCAKE/${efateSetupPk}`;
    return this.get(endpoint).pipe(map((data: any) => data?.Value ?? data));
  }

  saveEfateSetup(pObject: any): Observable<any> {
    const body = JSON.stringify(pObject);
    const headers = new HttpHeaders({ 'Content-type': 'application/json' });
    const endpoint = 'api/efate/setup';
    return this.put(endpoint, body, headers)
      .pipe(map((data: any) => data?.Value ?? data));
  }

  saveEfateCakeTopology(pObject: any): Observable<any> {
    const body = JSON.stringify(pObject);
    const headers = new HttpHeaders({ 'Content-type': 'application/json' });
    const endpoint = 'api/efate/cakeTopology';
    return this.put(endpoint, body, headers)
      .pipe(map((data: any) => data?.Value ?? data));
  }

  saveEfateCakeDataSet(pObject: any): Observable<any> {
    const body = JSON.stringify(pObject);
    const headers = new HttpHeaders({ 'Content-type': 'application/json' });
    const endpoint = 'api/efate/cakeDataSet';
    return this.put(endpoint, body, headers)
      .pipe(map((data: any) => data?.Value ?? data));
  }

  saveEfateStudyOptions(pObject: any): Observable<any> {
    const body = JSON.stringify(pObject);
    const headers = new HttpHeaders({ 'Content-type': 'application/json' });
    const endpoint = 'api/efate/studyOptions';
    return this.put(endpoint, body, headers)
      .pipe(map((data: any) => this.unwrapActionResult(data)));
  }

  private unwrapActionResult(data: any): any {
    if (data === null || data === undefined || typeof data !== 'object' || Array.isArray(data)) {
      return data;
    }

    if ('Value' in data) {
      return data.Value ?? undefined;
    }

    if ('value' in data) {
      return data.value ?? undefined;
    }

    return data;
  }
}